<template>
<!--  <print v-if="isPrint" :form="form" :board="board" />-->
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

<!--    구분-->
    <div>
      <h5 class="my-4"><i class="dot"></i> 구분</h5>
      <div class="writeGridContainer">
        <div class="time">
          <vs-radio v-model="form.구분" vs-name="구분" vs-value="상반기" :readonly="board.readonly">상반기</vs-radio>
          <vs-radio v-model="form.구분" vs-name="구분" vs-value="하반기" :readonly="board.readonly">하반기</vs-radio>
        </div>
      </div>
    </div>

    <!-- 점검표 -->
    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="점검표"
      :table-header-title="[{ text: '연번', width: '50px' }, { text: '의무 이행사항' }, { text: '관계법령' }, {text: '이행 확인 내용', width: '112px'}]"
      :table-header-check="[{ text: '이행' }, { text: '미이행' }, { text: '해당없음' }]"
      :tableHeaderNote="[{ text: '미이행 사유 및 조치 계획', width: '240px' }, { text: '비고', width: '240px' }]"
      v-model="inspectList"
      class="mt-5"
    >
      <template #customType="{ trData, id, input, noteIndex }">
        <div class="p-2">
          <ml-input class="w-full" v-model="trData['input0_0']" :readonly="board.readonly" />
          <div v-for="(field, index) in fieldsByType(trData.customTypes.length <= noteIndex ? trData.customTypes[0] : trData.customTypes[noteIndex])"
               :key="index" class="flex justify-between items-center mt-1">
            <span>{{ field.label }}</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData[field.inputKey] }}</p>
            <template v-else>
              <component :is="field.inputComponent" v-model="trData[`${field.inputKey}_${noteIndex}`]" :readonly="board.readonly" :style="field.style"/>
            </template>
          </div>
        </div>
      </template>
      <template #contentTooltip="{ index }">
        <vx-tooltip
          v-if="inspectList[index].tooltip.body"
          :title="inspectList[index].tooltip.text? inspectList[index].tooltip.text: ''"
          :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
          position="top" delay=".1s">
            <feather-icon icon="AlertCircleIcon"
                        style="cursor: pointer; width:18px; color: #7e72f2;"
                        @click="onClickToolTip(index, inspectList[index].tooltip.title)" />
        </vx-tooltip>
      </template>
    </table-inspect-merge>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <vs-popup v-if="popupIndex !== -1" :title="popupTitle" :active.sync="showContentPopup">
      <span v-html="inspectList[popupIndex].tooltip.body"/>
    </vs-popup>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import * as inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import FileUploader from "@/components/FileUploader.vue";
import Print from "@/views/boards/single-page/670/Print.vue";

export default {
  components: {
    Print,
    FileUploader,
    TableCustom,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      showContentPopup:false,
      popupIndex: -1,
      popupTitle: "",
      form: {
        stdInfo: {},

        구분: "",

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",

        inspectList: inspectData.inspectTable,

        photoList: [],
        fileList: [],
      },
      하반기아이템: inspectData.inspectTable.slice(16, 21)
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.구분': {
      immediate: true,
      handler(value) {
        if (value === '상반기') {
          this.inspectList = this.form.inspectList.filter(item => !(item.id >= 17 && item.id <= 21));
        }
        else {
          if (this.form.inspectList.length === 16) {
            this.inspectList = this.form.inspectList.concat(this.하반기아이템);
          }
          else {
            this.inspectList = this.form.inspectList;
          }
        }
      },
    },
  },
  computed: {
    inspectList: {
      get() {
        return this.form.inspectList;
      },
      set(value) {
        this.form.inspectList = value;
      },
    },
  },
  methods: {
    fieldsByType(type) {
      return [
        { label: '(정기)실시일', inputKey: 'input1', inputComponent: 'date-selector', style: { width: '130px' } },
        { label: '(수시)실시일', inputKey: 'input2', inputComponent: 'date-selector', style: { width: '130px' } },
        // Add more fields as needed
      ]
    },
    onClickToolTip(index, title) {
      this.popupIndex = index;
      this.popupTitle = title;
      this.showContentPopup = true;
    },
  },
};
</script>

<style scoped lang="scss"></style>
